/**
 * Created by rastwe on 1/16/2017.
 * @module $Name$
 * @extends React.Component
 */
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useDispatch, useSelector} from 'react-redux';
import {SVGICONS} from '@ey/icons';
import {labels} from '../../util/utils';
import ModalControl from '../Common/Modal/Modal';
import config from '../../../src/auth/config';
import * as TimeoutAction from '../../actions/timeoutactions';
import queryString from 'query-string';
import _ from 'lodash';
import TimeTrackerContainer from '../Common/Timetracker/TimeTrackerContainer';
import './index.scss';
import '@ey/motif-react-wrapper/ey-asu-motif.css';
import '@ey/styled-theme/styles.css';
import './main.less';

export default function Main(props) {
	const {children} = props;
	const [showLogoutModal, setShowLogoutModal] = useState(false);
	const [timerMessage, setTimerMessage] = useState(labels.sessionTimerMsg);
	const [intervalID, setIntervalID] = useState(null);

	const apponlinestate = useSelector((state) => state.apponlinestate),
		configurations = useSelector((state) => state.configurations),
		connectivitystate = useSelector((state) => state.connectivitystate),
		offlinePrep = useSelector((state) => state.offlinePrep),
		syncState = useSelector((state) => state.syncState),
		appVersionState = useSelector((state) => state.appVersion),
		sessionTimer = useSelector((state) => state.sessionTimer),
		userPreferences = useSelector((state) => state.userPreferences);

	const dispatch = useDispatch();
	const [onlineState, setOnlineState] = useState(apponlinestate);

	const calculateRemainingTime = () => {
		setTimerMessage(
			labels.sessionTimerMsg.replace('{0}', () => {
				let startTime = sessionTimer.logoutTimestamp;
				let endTime = startTime + config.logout_time;
				return Math.round((endTime - Date.now()) / 60000);
			})
		);
	};

	useEffect(() => {
		if (apponlinestate !== onlineState) {
			window.location.reload();
		}
	}, [apponlinestate]);

	useEffect(() => {
		if (sessionTimer.showPopup) {
			setShowLogoutModal(true);
			calculateRemainingTime();
			let _intervalID = setInterval(calculateRemainingTime, 60000);
			setIntervalID(_intervalID);
		} else if (sessionTimer.startLogout) {
			dispatch(TimeoutAction.logoutUser());
		}
	}, [sessionTimer]);

	useEffect(() => {
		if (appVersionState.upgrade) {
			localStorage.setItem('app.version', appVersionState.version);
			window.location.reload();
		}
	}, [appVersionState]);

	const logoutUser = (value) => {
		if (intervalID) {
			clearInterval(intervalID);
			setIntervalID(null);
		}
		dispatch(TimeoutAction.startLogout());
	};

	const isTrainingEnvironment =
		configurations && configurations.features && configurations.features.isTrainingEnvironment === true;

	const enableTimeTracker =
		configurations && configurations.features && configurations.features.enableTimeTracker === true;

	const classes = apponlinestate
		? offlinePrep
			? _.isBoolean(syncState) && syncState
				? 'syncstate'
				: isTrainingEnvironment
				? 'training '
				: ''
			: 'offlineprep'
		: _.isBoolean(connectivitystate) && connectivitystate
		? 'connection-available'
		: 'offline';

	const parsed = queryString.parse(window.location.search.toLowerCase());
	const view = parsed.view;

	return (
		<section className={`${classes} main key ${view === 'details' ? 'accountdetails' : ''}`}>
			{!apponlinestate ? (
				_.isBoolean(connectivitystate) && connectivitystate ? (
					<OfflineContainerwrapper className="connectionAvailable">
						<SVGICONS styleName="small" name="wifi" hoverText="" alt="connection available" />
						<span>{labels.connectionavilable}</span>
					</OfflineContainerwrapper>
				) : (
					<OfflineContainerwrapper className="workingOffline">
						<SVGICONS styleName="small" name="wifi-off" hoverText="" alt="offline" />
						<span>{labels.workingoffline}</span>
					</OfflineContainerwrapper>
				)
			) : !offlinePrep ? (
				<OfflineContainerwrapper className="prepareOffline">
					<span>{labels.prepareoffline}</span>
				</OfflineContainerwrapper>
			) : _.isBoolean(syncState) && syncState ? (
				<OfflineContainerwrapper className="syncInProgress">
					<span>{labels.syncinprogress}</span>
				</OfflineContainerwrapper>
			) : isTrainingEnvironment ? (
				<OfflineContainerwrapper className="training">
					<span>{labels.training}</span>
				</OfflineContainerwrapper>
			) : (
				''
			)}
			<MainContainerWrapper className="MainContainerWrapper customScrollbar">{children}</MainContainerWrapper>
			{/* {appVersionState.upgrade && (
				<StyledClientFilesAutoUpdate>
					<ClientFilesAutoUpdate
						label={labels.softwareUpdate}
						bodyContent={labels.updateMsg}
						updateNowText={labels.updateNow}
						onUpdateNow={() => {
							localStorage.setItem('app.version', appVersionState.version);
							window.location.reload();
						}}
					/>
				</StyledClientFilesAutoUpdate>
			)} */}

			<ModalControl
				title={labels.sessionPopupTitle}
				closeTitle={labels.close}
				closeBtnTitle={labels.logout}
				confirmBtnTitle={labels.continue}
				modalsize="small"
				onOkClick={() => {
					if (intervalID) {
						clearInterval(intervalID);
						setIntervalID(null);
					}
					dispatch(TimeoutAction.resetIdleTimer());
					setShowLogoutModal(false);
				}}
				onHide={logoutUser}
				setModalVisibility={showLogoutModal}
				show={showLogoutModal}
				showButtons
				modalContainerClass="SessionTimerModalContainer"
				modalbodystyle="SessionTimerModalBodyContainer"
			>
				<PopupContent>{timerMessage}</PopupContent>
			</ModalControl>

			<StyledTimetrackerContainer>
				{enableTimeTracker && !userPreferences?.isGuestUser && <TimeTrackerContainer />}
			</StyledTimetrackerContainer>
		</section>
	);
}

const MainContainerWrapper = styled.section`
	display: flex;
	flex-direction: column;
	flex: 1 1 0%;
	overflow-x: hidden;
	height: auto !important;
	scrollbar-gutter: stable;
	.FlexModal {
		.header {
			width: 100%;
			max-width: 2048px;
			align-self: center;
		}
	}
`;

const PopupContent = styled.section`
	font-size: var(--px-12);
	margin: var(--px-20) var(--px-20);
	line-height: var(--px-20);
`;

const OfflineContainerwrapper = styled.section`
	box-shadow: 0 0 0 0 var(--green-500);
	position: absolute;
	font-weight: 700;
	vertical-align: middle;
	text-align: center;
	left: 45%;
	display: flex;
	height: auto;
	padding: var(--px-5);
	z-index: 99;
	&.syncInProgress,
	&.connectionAvailable {
		background: var(--teal-300);
	}
	&.prepareOffline,
	&.workingOffline {
		background: var(--teal-500);
	}
	&.training {
		background: var(--purple-400);
		padding: 0;
	}

	span {
		text-align: center;
		margin: var(--px-3);
		padding: 0;
		font-weight: bold;
		width: auto;
		vertical-align: top;
		line-height: initial;
		color: var(--neutrals-00white);
		font-size: var(--px-12);
	}
	svg {
		fill: var(--neutrals-00white);
	}
`;

const StyledTimetrackerContainer = styled.section`
	//position: relative;
`;
